import React, { Component } from "react"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import MetaTags from 'react-meta-tags';
import { withTranslation } from "react-i18next"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import { map } from "lodash"
import { Link } from "react-router-dom"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { getProjectUUIDAction, addProjectInvite, getProjectInvite, deleteProjectInvite, getProjectInviteAtt, updateProjectInvite } from "../../../store/projects/actions"
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeleteModal from "../../../components/Common/DeleteModal";
import ProjectSidebar from "../../../components/VerticalLayout/ProjectSidebar";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import Moment from 'react-moment';
import { CSVLink } from 'react-csv';
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  TabContent,
  FormGroup,
  Label,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  CardHeader,
} from "reactstrap"
import { event } from "jquery";
import WebpagesMenu from "./menu/webpages-menu";
import WebPageBreadcrumbs from "components/Common/WebpageBreadcrumb";
import SaveButton from "components/buttons/save";
import UpdateButton from "components/buttons/updateBtn";
import img1 from "../../../assets/img/doc-1.png"
import img2 from "../../../assets/img/doc-2.png"
import img3 from "../../../assets/img/doc-3.png"
import RsLink from "components/buttons/rsLink";
import { API_URL } from "helpers/app_url";
import step1 from "../../../assets/img/step-1.png"
import step2 from "../../../assets/img/step-2.png"
import step3 from "../../../assets/img/step-3.png"
import arrowImg from "../../../assets/img/arrow-img.png"
import createIcon from "../../../assets/img/create-icon.png"
import allIcon from "../../../assets/img/all-icon.png"
import axios from "axios";
import TimePicker from "components/dropdowns/Timepicker";
import moment from "moment";
import SafeField from "helpers/SafeField";
const csvHeaders = [
  { label: 'Name', key: 'name' },
  { label: 'Phone', key: 'phoneNo' },
  { label: 'Email', key: 'email' },
  { label: 'Event Slot', key: 'eventSlot' },
  { label: 'Is Realtor', key: 'isRealator' }
];
class projectRsvp extends Component {
  constructor(props) {
    super(props)
    this.state = {
        event:''
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this.showallAtt = this.showallAtt.bind(this);
  }
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));
  }
  toggleAtt() {
    this.setState(prevState => ({
      isAtt: !prevState.isAtt
    }));
  }
  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  onClickDelete = (event) => {
    this.setState({ event: event });
    this.setState({ deleteModal: true });
  };

  handleDelete = () => {
    const { onDelete } = this.props;
    const { event } = this.state;
   
    if (event.id !== undefined) {
      onDelete(event);
      this.setState({ deleteModal: false });
    }
  };
  handleStartTime = (setFieldValue, values) => {
    const { startHrs, startMin, startDif } = values;
    const hours = parseInt(startHrs, 10);
    const minutes = parseInt(startMin, 10);
    const meridiem = startDif === 'PM' && hours < 12 ? hours + 12 : hours;
    const time = `${meridiem}:${minutes < 10 ? '0' + minutes : minutes}`;

    setFieldValue('eventStartTime', time);
  };

  handleEndTime = (setFieldValue, values) => {
    const { endHrs, endMin, endDif } = values;
    const hours = parseInt(endHrs, 10);
    const minutes = parseInt(endMin, 10);
    const meridiem = endDif === 'PM' && hours < 12 ? hours + 12 : hours;
    const time = `${meridiem}:${minutes < 10 ? '0' + minutes : minutes}`;

    setFieldValue('eventEndTime', time);
  };
  

  
  componentDidMount() {

    const { match: { params }, ongetProjectUUIDAction, onGetProjectInvite } = this.props;

    if (params && params.projectId) {
      ongetProjectUUIDAction(params.projectId);
      onGetProjectInvite(params.projectId)
    
    }
  }
 
  handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;
        
        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        setFieldValue('address', place.formatted_address);
        setFieldValue('longitude', longitude);
        setFieldValue('latitude', latitude);
      })
      .catch(error => console.error('Error', error));
  };
  handleSubmit = (values,  { resetForm }) => {
    const payload = {
      projectId: values.projectId,
      projectGuid:values.projectGuid,
      projectName: values.projectName,
      eventName: values.eventName,
      eventDate: moment(values.eventDate).format("YYYY-MM-DD"),
      eventStartTime: values.eventStartTime,
      eventEndTime: values.eventEndTime,
      eventType: parseInt(values.eventType),
      address: values.address,
      location: values.location,
      longitude: values.longitude.toString(),
      latitude: values.latitude.toString(),
      AgentId:parseInt(localStorage.getItem("userId")),
      IsActive:true,
      eventNotes: values.eventNotes,
    };
    this.props.addProjectInvite(payload)
    resetForm();
  
  }
  toggleRightCanvas() {
    this.setState({ event: "", isEdit: false, isRight: !this.state.isRight });
    this.toggle();
  }
  toggleRightCanvas = arg => {
    const event = arg;
    this.setState({
      event: {
          id: event.id,
          projectEventInviteId:event.projectEventInviteId,
          projectId:event.projectId,
          projectGuid:event.projectGuid,
          projectName:event.projectName,
          eventName:event.eventName,
          eventDate:event.eventDate,
          eventStartTime:event.eventStartTime,
          eventEndTime:event.eventEndTime,
          eventType:event.eventType,
          address:event.address,
          location:event.location,
          longitude:event.longitude,
          latitude:event.latitude,
          agentId:event.agentId,
          isActive:event.isActive,
          eventNotes:event.eventNotes,
      },
      isEdit: true,
    });
    this.toggle();
  };
  showallAtt() {
    this.setState({ event: "", isEdit: false, isAtt: !this.state.isAtt });
    this.toggleAtt();
  }
  showallAtt = arg => {
    const event = arg;
    const { onGetProjectInviteAtt } = this.props;
    this.setState({
      event: {
          id:event.id
      }
    });
    onGetProjectInviteAtt(event.id);
    this.toggleAtt();
  };
  parseTime(time) {
    if (!time) {
      return { hour: '', minute: '', amPm: 'AM' }; // Default values if time is not provided
    }
    const [hour, minute] = time.split(":").map(Number);
    const isPM = hour >= 12;
    const formattedHour = hour % 12 || 12; // Convert 0 to 12 for 12-hour format
    const amPm = isPM ? "PM" : "AM";
    return { hour: formattedHour, minute, amPm };
  }
  saveAsLead = (event) => {
  const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = 'Bearer ' + token;
       const payload = {
          registrationId: event.id,
          agentId: parseInt(localStorage.getItem("userId"))
  };
  toast.loading('Please wait...');
    axios.post(`${API_URL}ProjectEventInviteRegistration/ConvertLeadToProjectLead`, payload, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `${str}`,
    },
  })
  .then(response => {
    if (response.data && response.data.success) {
        toast.dismiss();
        toast.success('Lead converted successfully!');
        this.showallAtt();
    } else {
     toast.dismiss();
        toast.error('Some error occurred while converting lead.');
    }
  })
  .catch(error => {
    console.error('Error converting lead:', error);
    // Optionally show error to user
  });
  }
  render() {
    const { projectData, invitesdata, attdatas, onUpdateProjectInvite, isResponsive } = this.props;
    const { isEdit, deleteModal } = this.state;
    const event = this.state.event;
    //
    const { hour: startHrs, minute: startMin, amPm: startDif } = this.parseTime(event?.eventStartTime);
    const { hour: endHrs, minute: endMin, amPm: endDif } = this.parseTime(event?.eventEndTime);
    const formattedAttendees = attdatas?.map((a) => ({
  ...a,
  isRealator: a.isRealator ? 'Yes' : 'No',
}));
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
       
        <ToastContainer autoClose={2000} />
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDelete}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <div className="page-content project-page-content">

          <MetaTags>
            <title>Campaigns | Realty Space</title>
          </MetaTags>
          <Container fluid className="">
                <Row>
                    <Col sm='2' className="" >
                    <ProjectSidebar isResponsive={isResponsive} />
                     </Col>
                <Col sm='10' className="">
                <Row className="project-header">
                   <Col sm="7">
                <WebPageBreadcrumbs title={this.props.t("Projects")} breadcrumbItem={this.props.t("Invite / RSVP Page")} />
                </Col>
                <Col sm="4">
                <h2 className="">{this.props.t( projectData.projectName)}</h2>
                </Col>
                </Row>
                <WebpagesMenu isResponsive={isResponsive} />

                    <Row>
              <Col sm="3" className="d-flex">
                <Card className="border-full w-100">
                    <CardHeader><h5 className="font-size-18" style={{fontWeight:'bold'}}><img src={step1}  width="40" className="me-2" /> Purpose</h5></CardHeader>
                    <CardBody className="d-flex flex-column">
                        <p className="text-dark font-size-16">Manage and promote pre-construction project events digitally, capture attendee interest, and convert prospects into leads.</p>
                    </CardBody>
                </Card>
              </Col>
                            <Col sm="5" className="d-flex">
                            <Card className="border-full  w-100 mt-4">
                                <CardHeader><h5 className="font-size-18" style={{fontWeight:'bold'}}><img src={step2}  width="40" className="me-2" /> How it works</h5></CardHeader>
                                <CardBody className="d-flex flex-column">
                                      <ol className="text-dark font-size-16">
                                          <li>Agents create an event by specifying the date, time, type, and location.</li>
                                          <li> Once created, the event is automatically added to the Events Grid on the page.</li>
                                          <li> From the Events Grid, agents can send invites to prospects.</li>
                                          <li> Attendance lists can be viewed under the Action link for each event.</li>
                                          <li>If an attendee shows interest, they can be directly added as a lead in the system.</li>
                                      
                                      </ol>
                                </CardBody>
                            </Card>
                          </Col>

                          <Col sm="4" className={`d-flex ${isResponsive ? '' : 'ps-0'}`}>
                            <Card className="border-full w-100 mt-4">
                                <CardHeader><h5 className="font-size-18" style={{fontWeight:'bold'}}><img src={step3}  width="40" className="me-2" /> How To Use</h5></CardHeader>
                                <CardBody className="d-flex flex-column">
                              
                                      <ol className="text-dark font-size-16">
                                          <li>Create a new event by entering the date, time, type, and location.</li>
                                          <li> Use the Events Grid to:
                                            <ul>
                                              <li>Send invites to prospects.</li>
                                              <li>View attendee lists under the Action menu.</li>
                                                <li>Convert interested attendees into leads with a single step.</li>
                                            </ul>
                                          </li>
                                          
                                      </ol>

                                      
                              
                                </CardBody>
                            </Card>
                          </Col>
                        </Row>
                <Row>
                  <Col sm="12">
                    <Card className="border-full mt-4">
                        <CardBody>
                          <h5 className="font-size-18 mb-20" style={{fontWeight:'bold'}}><img src={allIcon}  width="40" className="me-2" /> All Events</h5>
                          <table className="table table-striped">
                                                            <thead className="">
                                                                <tr>
                                                                    <th>Name</th>
                                                                    <th>Date</th>
                                                                   
                                                                    <th>Start Time</th>
                                                                    <th>End Time</th>
                                                                     {!isResponsive &&(
                                                                      <>
                                                                       <th>Type</th>
                                                                    <th>Location</th>
                                                                    <th>Link</th>
                                                                    <th>Send invites</th>
                                                                    <th>Action</th>
                                                                      </>
                                                                    )}
                                                                   


                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                            {map(invitesdata, (event, prokey) => (
                                                             <tr key={prokey}>
                                                              <td>{event.eventName}</td>
                                                              <td><Moment format="D MMM YY">{event.eventDate}</Moment></td>
                                                              <td><Moment format="hh:mm A" parse="HH:mm">{event.eventStartTime}</Moment></td>
                                                              <td><Moment format="hh:mm A" parse="HH:mm">{event.eventEndTime}</Moment></td>
                                                               {!isResponsive &&(
                                                                      <>
                                                              <td>{event.eventType === 1 ? 'In-person': 'Online'}</td>
                                                              <td>{event.eventType === 1 ? event.address : event.location}</td>
                                                              <td><a href={"https://openhouseinvite.realtyspacehub.com/" + event.projectEventInviteId} rel="noreferrer" target="_blank">View</a></td>
                                                              <td><Link to={"/pre-construction/invite-editor/" + event.projectGuid + "/" + event.projectEventInviteId + "/41"} className="btn btn-primary">Send Invite</Link></td>
                                                              <td>
                                                              <UncontrolledDropdown direction="top">
                                                                    <DropdownToggle className="btn btn-action" type="button" id="defaultDropdown">
                                                                      Action <i className="mdi mdi-chevron-down"></i>
                                                                    </DropdownToggle>
                                                                    <DropdownMenu>
                                                                     <DropdownItem tag={Link} onClick={() => this.toggleRightCanvas(event)}>Edit</DropdownItem> 
                                                                      <DropdownItem tag={Link} onClick={() => this.showallAtt(event)}>View Attendees</DropdownItem>
                                                                      <DropdownItem tag={Link} onClick={() => this.onClickDelete(event)}>Delete</DropdownItem>


                                                                    </DropdownMenu>
                                                                  </UncontrolledDropdown>
                                                              </td>
                                                              </>
                                                               )}
                                                             </tr>
                                                            ))}
                                                            </tbody>
                                                        </table>
                           
                         
                       
                        </CardBody>
                      </Card>
                  </Col>
                </Row>
            <Row>

              <Col sm="12">
            <Card className="border-full mt-4">
                  <CardBody>
                     <h5 className="font-size-18 mb-20" style={{fontWeight:'bold'}}><img src={createIcon}  width="40" className="me-2" /> Create Event</h5>
                    <TabContent
                      activeTab={this.state.activeTab}
                      className="p-3 text-muted"
                    >
                          <Row className="align-items-stretch">
                            <Col sm="12">
                            <Formik
              enableReinitialize={true}
              initialValues={{
                projectId:projectData.id,
                projectGuid:projectData.preConsProjectGuid,
                projectName:projectData.projectName,
                eventType:'1',
                address:'',
                longitude:'',
                latitude:'',
                eventStartTime:'',
                eventEndTime:'',
                eventName: (this.state && this.state.eventName) || "",
                eventDate: (this.state && this.state.eventDate) || "",
               
                location: (this.state && this.state.location) || "",
               eventNotes:''

              }}
              validationSchema={Yup.object().shape({
                eventName: Yup.string().required("This is Required"),
                eventDate: Yup.string().required("This is Required"),
                eventStartTime : Yup.string().required("This is Required"),
                eventEndTime : Yup.string().required("This is Required"),
                eventType : Yup.string().required("This is Required"),
                address: Yup.string().when('eventType', {
                  is: '1',
                  then: Yup.string().required('This is Required'),
                }),
                location: Yup.string().when('eventType', {
                  is: '2',
                  then: Yup.string().required('This is Required'),
                }),
              })}

              onSubmit={this.handleSubmit}
            >
              {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
                <Form
                  className="needs-validation"
                >
                    <Row>
                  
                    <Col md="4">
                    <FormGroup className="mb-3">
                                        <Label htmlFor="eventName">
                          {this.props.t("Event Name *")}
                        </Label>
                                       <SafeField
                                         name="eventName"
                                         className={
                                          "form-control" +
                                          (errors.eventName && touched.eventName
                                          ? " is-invalid"
                                          : "")
                                        }
                                         onChange={handleChange}
                                         type="text"
                                       />

                                       <ErrorMessage
                                         name="eventName"
                                         component="div"
                                         className="invalid-feedback"
                                       />
                                     </FormGroup>
                       
                    </Col>
                    <Col md="4">
                     <FormGroup className="mb-3">
                     <Label htmlFor="eventDate *">
                          {this.props.t("Event Date *")}
                        </Label>
                    <Flatpickr
                        className={
                            "form-control" +
                            (errors.eventDate && touched.eventDate
                            ? " is-invalid"
                            : "")
                        }
                        placeholder=""
                        onChange={(value) => setFieldValue('eventDate', value[0])}
                        options={{
                            altInput: false,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d",
                            minDate: "today"
                        }}
                                  />
                        <ErrorMessage
                          name="eventDate"
                          component="div"
                          className="invalid-feedback"
                        />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                      <TimePicker
                        name="eventStartTime"
                        label="Start Time *"
                        value={values.eventStartTime}
                        onChange={(val) => setFieldValue("eventStartTime", val)}
                        onBlur={() => setFieldTouched("eventStartTime", true)}
                        minTime={null}
                        error={errors.eventStartTime}
                        touched={touched.eventStartTime}
                      />
                    </Col>
                     <Col md="2">
                      <TimePicker
                      name="eventEndTime"
                      label="End Time *"
                      value={values.eventEndTime}
                      onChange={(val) => setFieldValue("eventEndTime", val)}
                      onBlur={() => setFieldTouched("eventEndTime", true)}
                      minTime={values.eventStartTime}
                      disabled={!values.eventStartTime}
                      error={errors.eventEndTime}
                      touched={touched.eventEndTime}
                    />
                    </Col>
                  </Row>

                 
                 
              
                  <Row>
                   
                    <Col md="2">
                    <FormGroup className="mb-3">
                        <Label htmlFor="eventType">
                          {this.props.t("Event Type")}
                        </Label>
                       <div className="clearfix"></div>
                     
                    <div className="btn-group" role="group">
                        <SafeField
                          type="radio"
                          className="btn-check"
                          name="eventType"
                          id="btnradio4"
                          value="1"
                          checked={values.eventType === '1'}
                          onChange={e => {
                            handleChange(e);
                            setFieldValue('address', '');
                            setFieldValue('location', '');
                            setFieldValue('longitude', '');
                            setFieldValue('latitude', '');
                          }}
                        />
                        <label className="btn btn-outline-secondary" htmlFor="btnradio4">In-person</label>

                        <SafeField
                          type="radio"
                          className="btn-check"
                          name="eventType"
                          id="btnradio5"
                          value="2"
                          checked={values.eventType === '2'}
                          onChange={e => {
                            handleChange(e);
                            setFieldValue('address', '');
                            setFieldValue('location', '');
                            setFieldValue('longitude', '');
                            setFieldValue('latitude', '');
                          }}
                        />
                        <label className="btn btn-outline-secondary" htmlFor="btnradio5">Online</label>
                      </div>
                    <ErrorMessage
                          name="eventType"
                          component="div"
                          className="invalid-feedback"
                        />
                         </FormGroup>
                    </Col>
                   
                    {values.eventType === '1' && (
                  
                   
                    <Col md="10">
                    <FormGroup className="mb-3">
                      <Label htmlFor="addNote">
                          {this.props.t("Event Address *")}
                        </Label>                 
                    <PlacesAutocomplete
                            value={values.address}
                              onChange={(value) => setFieldValue('address', value)}
                              onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                            >
                              {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                <div>
                                  <input
                                      name="address"
                                    {...getInputProps({
                                      placeholder: 'Enter Address...',
                                      className: `form-control ${
                                        errors.address &&
                                        touched.address
                                          ? "is-invalid"
                                          : ""
                                      }`,
                                        onBlur: () => setFieldTouched(`address`, true), 
                                     
                                    })}
                                  />
                                  <div className="">
                                    {loading ? <div>Loading...</div> : null}

                                    {suggestions.map((suggestion, i) => {
                                      const className = suggestion.active
                                        ? 'suggestion-item--active'
                                        : 'suggestion-item';
                                      const style = suggestion.active
                                        ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                        : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                      return (
                                        <div
                                        key={i}
                                          {...getSuggestionItemProps(suggestion, {
                                            style,
                                          })}
                                        >
                                          {suggestion.description}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )}
                            </PlacesAutocomplete>
                                   {errors.address &&
                                              touched.address ? (
                                                <div className="invalid-feedback d-block">
                                                  {errors.address}
                                                </div>
                                              ) : null}
                                       
                                      </FormGroup>
                    </Col>
                   
                    )}
                  {values.eventType === '2' && (
                   
                    <Col md="10">
                    <FormGroup className="mb-3">
                              <Label htmlFor="addNote">
                          {this.props.t("Event Link *")}
                        </Label>          
                                        <SafeField
                                          name="location"
                                          className={
                                            "form-control" +
                                            (errors.location && touched.location
                                            ? " is-invalid"
                                            : "")
                                        }
                                          onChange={handleChange}
                                          type="text"
                                        />

                                        <ErrorMessage
                                          name="location"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                    </Col>
                   
                    )}
                </Row>

                        <Row>
                  
                    <Col md="12">
                     <FormGroup className="mb-3">
                    <Label htmlFor="eventNotes">
                          {this.props.t("Additional event details ( Use this space for extra notes your guests should know, like parking info, access to event etc)")}
                        </Label>
                   
                                       
                                       <SafeField
                                         name="eventNotes"
                                         className={
                                          "form-control" +
                                          (errors.eventNotes && touched.eventNotes
                                          ? " is-invalid"
                                          : "")
                                        }
                                         onChange={handleChange}
                                         as="textarea"
                                       />

                                       <ErrorMessage
                                         name="eventNotes"
                                         component="div"
                                         className="invalid-feedback"
                                       />
                                     </FormGroup>
                       
                    </Col>
                  </Row>
                  <div className="clearfix">
                    <SaveButton>Save</SaveButton>
                   </div>


                </Form>
              )}
                      </Formik>
                            </Col>
                           
                          </Row>
                            
                     
                    </TabContent>
                  </CardBody>
                </Card>

              
              </Col>
            </Row>


            <Row>

            </Row>
            </Col>
            </Row>
          </Container>
          <Offcanvas
              isOpen={this.state.isAtt}
              direction="end"
              toggle={this.showallAtt}
              //className="attCanvas"
              style={{width:900}}
             
            >
              <OffcanvasHeader className="submittedWorksheet" toggle={this.showallAtt}>
              View Attendees  <span className="float-end">
              {formattedAttendees && formattedAttendees.length > 0 && (   
              <CSVLink
                data={formattedAttendees}
                headers={csvHeaders}
                filename="attendees.csv"
                className="float-end"
                style={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
              >
                <i className="bx bx-download"></i>
              </CSVLink>
              )}
  </span>
              </OffcanvasHeader>
              <OffcanvasBody>
              <table className="table table-striped">
                                                            <thead className="">
                                                                <tr>
                                                                    <th>Name</th>
                                                                    <th>Phone</th>
                                                                    <th>Email</th>
                                                                    <th>Event Slot</th>
                                                                    <th>Is Realtor</th>
                                                                     <th></th>
                                                                    

                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                            {map(attdatas, (attdata, prokey) => (
                                                             <tr key={prokey}>
                                                              <td>{attdata.name}</td>
                                                              <td>{attdata.phoneNo}</td>
                                                              <td>{attdata.email}</td>
                                                              <td>{attdata.eventSlot}</td>
                                                              <td>{attdata.isRealator ? 'Yes' : 'No' }</td>
                                                              <td>
                                                                {attdata.leadId > 0 ?
                                                                 <RsLink className="btn-light" disabled={true} iconClass="">Save as Lead</RsLink>
                                                                :
                                                               
                                                                <RsLink className="btn-action" onClick={() => this.saveAsLead(attdata)} iconClass="">Save as Lead</RsLink>
                                                                 }
                                                                </td>
                                                              
                                                             </tr>
                                                            ))}
                                                            </tbody>
                                                        </table>
              </OffcanvasBody>
            </Offcanvas>
          <Offcanvas
              isOpen={this.state.isRight}
              direction="end"
              toggle={this.toggleRightCanvas}
            >
              <OffcanvasHeader toggle={this.toggleRightCanvas}>
                Update Event
              </OffcanvasHeader>
              <OffcanvasBody>
              <Formik
              enableReinitialize={true}
              initialValues={{
                id: event.id,
                projectEventInviteId:event.projectEventInviteId,
                projectId:event.projectId,
                projectGuid:event.projectGuid,
                projectName:event.projectName,
                eventName:event.eventName,
                eventDate:event.eventDate,
                eventStartTime:event.eventStartTime,
                eventEndTime:event.eventEndTime,
                
                eventType:parseInt(event.eventType),
                address:event.address,
                location:event.location,
                longitude:event.longitude,
                latitude:event.latitude,
                agentId:event.agentId,
                isActive:event.isActive,
                eventNotes:event.eventNotes,
               

              }}
              validationSchema={Yup.object().shape({
                eventName: Yup.string().required("This is Required"),
                eventDate: Yup.string().required("This is Required"),
                eventStartTime : Yup.string().required("This is Required"),
                eventEndTime : Yup.string().required("This is Required"),
                
                eventType : Yup.string().required("This is Required"),
                address: Yup.string().when('eventType', {
                  is: '1',
                  then: Yup.string().required('This is Required'),
                }),
                location: Yup.string().when('eventType', {
                  is: '2',
                  then: Yup.string().required('This is Required'),
                }),
              })}

              onSubmit={values => {
                //
               
                  const updateAllocation = {
                  
                    id: values.id,
                    projectEventInviteId:values.projectEventInviteId,
                    projectId:values.projectId,
                    projectGuid:values.projectGuid,
                    projectName:values.projectName,
                    eventName:values.eventName,
                    eventDate:values.eventDate,
                    eventStartTime:values.eventStartTime,
                    eventEndTime:event.eventEndTime,
                    eventType:event.eventType,
                    address:values.address,
                    location:values.location,
                    longitude:values.longitude.toString(),
                    latitude:values.latitude.toString(),
                    agentId:values.agentId,
                    isActive:values.isActive,
                    eventNotes:values.eventNotes,
                  };

                  onUpdateProjectInvite(updateAllocation);
                
                this.toggle();
              }}
            >
              {({ errors, touched, values, handleChange, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >
                    <Row>
                   
                    <Col md="12">
                    <FormGroup className="mb-3">
                    <Label htmlFor="eventName">
                          {this.props.t("Name")}
                        </Label>  
                                       <SafeField
                                         name="eventName"
                                         className={
                                          "form-control" +
                                          (errors.eventName && touched.eventName
                                          ? " is-invalid"
                                          : "")
                                        }
                                         onChange={handleChange}
                                         type="text"
                                       />

                                       <ErrorMessage
                                         name="eventName"
                                         component="div"
                                         className="invalid-feedback"
                                       />
                                     </FormGroup>
                       
                    </Col>
                  </Row>

                  <Row>
                   
                    <Col md="12">
                    <FormGroup className="mb-3">
                        <Label htmlFor="eventDate">
                          {this.props.t("Enter date for invite")}
                        </Label>
                       
                     
                    <Flatpickr
                        className={
                            "form-control" +
                            (errors.eventDate && touched.eventDate
                            ? " is-invalid"
                            : "")
                        }
                       value={values.eventDate}
                        onChange={(value) => setFieldValue('eventDate', value[0])}
                        options={{
                            altInput: false,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d",
                            minDate:'today'
                        }}
                                  />
                       </FormGroup>
                        <ErrorMessage
                          name="eventDate"
                          component="div"
                          className="invalid-feedback"
                        />
                    </Col>
                  </Row>
                  <Row style={{marginTop:10}}>
                     <Col md="6">
                      <TimePicker
                        name="eventStartTime"
                        label="Start Time *"
                        value={values.eventStartTime}
                        onChange={(val) => setFieldValue("eventStartTime", val)}
                        onBlur={() => setFieldTouched("eventStartTime", true)}
                        minTime={null}
                        error={errors.eventStartTime}
                        touched={touched.eventStartTime}
                      />
                    </Col>
                     <Col md="6">
                      <TimePicker
                      name="eventEndTime"
                      label="End Time *"
                      value={values.eventEndTime}
                      onChange={(val) => setFieldValue("eventEndTime", val)}
                      onBlur={() => setFieldTouched("eventEndTime", true)}
                      minTime={values.eventStartTime}
                      disabled={!values.eventStartTime}
                      error={errors.eventEndTime}
                      touched={touched.eventEndTime}
                    />
                    </Col>

                  </Row>
                 
                  <Row style={{marginTop:20}}>
                    <Col md="12">
                    <Label htmlFor="eventType">
                          {this.props.t("Event Type")}
                        </Label>
                    </Col>
                    <Col md="6">
                    <div className="btn-group" role="group">
                        <SafeField
                          type="radio"
                          className="btn-check"
                          name="eventType"
                          id="btnradio51"
                          value={1}
                          checked={values.eventType === 1}
                          onChange={e => {
                            handleChange(e);
                            setFieldValue('address', '');
                            setFieldValue('location', '');
                            setFieldValue('longitude', '');
                            setFieldValue('latitude', '');
                          }}
                        />
                        <label className="btn btn-outline-secondary" htmlFor="btnradio5">In-person</label>

                        <SafeField
                          type="radio"
                          className="btn-check"
                          name="eventType"
                          id="btnradio61"
                          value={2}
                          checked={values.eventType === 2}
                          onChange={e => {
                            handleChange(e);
                            setFieldValue('address', '');
                            setFieldValue('location', '');
                            setFieldValue('longitude', '');
                            setFieldValue('latitude', '');
                          }}
                        />
                        <label className="btn btn-outline-secondary" htmlFor="btnradio6">Online</label>
                      </div>
                    <ErrorMessage
                          name="eventTypes"
                          component="div"
                          className="invalid-feedback"
                        />
                    </Col>
                    </Row>
                    {values.eventType === 1 && (
                    <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="addNote">
                          {this.props.t("Event Address")}
                        </Label>
                       
                      </FormGroup>
                    </Col>
                    <Col md="12">
                    <FormGroup className="mb-3">
                                       
                    <PlacesAutocomplete
                            value={values.address}
                              onChange={(value) => setFieldValue('address', value)}
                              onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                            >
                              {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                <div>
                                  <input
                                    {...getInputProps({
                                      placeholder: 'Enter Address...',
                                      className: 'form-control',
                                     
                                    })}
                                  />
                                  <div className="">
                                    {loading ? <div>Loading...</div> : null}

                                    {suggestions.map((suggestion, i) => {
                                      const className = suggestion.active
                                        ? 'suggestion-item--active'
                                        : 'suggestion-item';
                                      const style = suggestion.active
                                        ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                        : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                      return (
                                        <div
                                        key={i}
                                          {...getSuggestionItemProps(suggestion, {
                                            style,
                                          })}
                                        >
                                          {suggestion.description}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )}
                            </PlacesAutocomplete>

                                        <ErrorMessage
                                          name="eventLocation"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                    </Col>
                    </Row>
                    )}
                  {values.eventType === 2 && (
                    <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="addNote">
                          {this.props.t("Event Link")}
                        </Label>
                       
                      </FormGroup>
                    </Col>
                    <Col md="12">
                    <FormGroup className="mb-3">
                                       
                                        <SafeField
                                          name="location"
                                          className={
                                            "form-control" +
                                            (errors.location && touched.location
                                            ? " is-invalid"
                                            : "")
                                        }
                                          onChange={handleChange}
                                          type="text"
                                        />

                                        <ErrorMessage
                                          name="location"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                    </Col>
                    </Row>
                    
                    )}
                    <Row>
                      <Col sm="12">
                       <FormGroup className="mb-3">
                        <Label htmlFor="eventNotes">
                          {this.props.t("Event Notes")}
                        </Label>
                       
                      </FormGroup>
                        <FormGroup className="mb-3">
                                       
                                       <SafeField
                                         name="eventNotes"
                                         className={
                                          "form-control" +
                                          (errors.eventNotes && touched.eventNotes
                                          ? " is-invalid"
                                          : "")
                                        }
                                         onChange={handleChange}
                                         as="textarea"
                                       />

                                       <ErrorMessage
                                         name="eventNotes"
                                         component="div"
                                         className="invalid-feedback"
                                       />
                                     </FormGroup>
                      </Col>
                    </Row>
                  <div className="clearfix"><UpdateButton>Update</UpdateButton></div>


                </Form>
              )}
            </Formik>                                            
              </OffcanvasBody>
            </Offcanvas>
        </div>
      </React.Fragment>
    )
  }
}

projectRsvp.propTypes = {
  t: PropTypes.any,
  history: PropTypes.func,
  match: PropTypes.object,
  ongetProjectUUIDAction: PropTypes.func,
  projectData: PropTypes.object,
 loading: PropTypes.object,
 addProjectInvite:PropTypes.func,
 onGetProjectInvite:PropTypes.func,
 invitesdata:PropTypes.array,
 onDelete:PropTypes.func,
 onGetProjectInviteAtt:PropTypes.func,
 attdatas:PropTypes.array,
 onUpdateProjectInvite:PropTypes.func,
 isResponsive:PropTypes.object
}
const mapStateToProps = ({ Project }) => (
  {
    projectData: Project.projectData,
    invitesdata:Project.invitesdata,
    loading: Project.loading,
    attdatas:Project.attdatas


  })
const mapDispatchToProps = dispatch => ({
  ongetProjectUUIDAction: (id) => dispatch(getProjectUUIDAction(id)),
  addProjectInvite: (data) => dispatch(addProjectInvite(data)),
  onGetProjectInvite:(projectId) => dispatch(getProjectInvite(projectId)),
  onDelete:(id) => dispatch(deleteProjectInvite(id)),
  onGetProjectInviteAtt:(EventId) => dispatch(getProjectInviteAtt(EventId)),
  onUpdateProjectInvite: (data) => dispatch(updateProjectInvite(data)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(projectRsvp)))
